import { render } from "./Oops.vue?vue&type=template&id=a0134694&scoped=true"
import script from "./Oops.vue?vue&type=script&lang=js"
export * from "./Oops.vue?vue&type=script&lang=js"

import "./Oops.vue?vue&type=style&index=0&id=a0134694&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0134694"]])

export default __exports__